import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    reportParams: {},
    activeTabName: "payslip",
  },
  actions,
  mutations,
};
